import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateMoveAssetsOperationMutationVariables = Types.Exact<{
  input: Types.CreateMoveAssetsOperationInput;
}>;


export type CreateMoveAssetsOperationMutation = { __typename?: 'Mutation', createMoveAssetsOperation?: { __typename?: 'CreateMoveAssetsOperationPayload', assetOperation?: { __typename?: 'CopyAssetsOperation', id?: string | null } | { __typename?: 'DeleteAssetsOperation', id?: string | null } | { __typename?: 'HardDeleteAssetsOperation', id?: string | null } | { __typename?: 'MoveAssetsOperation', id?: string | null } | { __typename?: 'UpdateAssetFieldValuesOperation', id?: string | null } | null } | null };


export const CreateMoveAssetsOperation = /*#__PURE__*/ gql`
    mutation CreateMoveAssetsOperation($input: CreateMoveAssetsOperationInput!) {
  createMoveAssetsOperation(input: $input) {
    assetOperation {
      id
    }
  }
}
    ` as unknown as DocumentNode<CreateMoveAssetsOperationMutation, CreateMoveAssetsOperationMutationVariables>;

          

          export const useCreateMoveAssetsOperationMutation = (options?:MutationHookOptions<CreateMoveAssetsOperationMutation, CreateMoveAssetsOperationMutationVariables>) => useMutation(CreateMoveAssetsOperation, options);
          

          export type CreateMoveAssetsOperationMutationOptions = MutationHookOptions<CreateMoveAssetsOperationMutation, CreateMoveAssetsOperationMutationVariables>;

          

          export type CreateMoveAssetsOperationMutationResult = ReturnType<typeof useCreateMoveAssetsOperationMutation>[1];

          
